import Vue from 'vue';
const TorreControlInstance = new Vue();
export default TorreControlInstance;
